import { NgClass } from '@angular/common';
import { Component } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { BaseCellRendererComponent } from '@examdojo/ag-grid';
import { MatTooltipTruncateDirective } from '@examdojo/core/mat-tooltip-truncate';
import { QUESTION_STATUS_TO_LABEL, QuestionItemV2, QuestionStatus } from '@examdojo/models/question';

@Component({
  selector: 'exam-question-list-status-cell-renderer',
  template: `
    @if (status) {
      <div
        [ngClass]="statusClass"
        class="inline-flex max-w-full overflow-hidden rounded-[6px] px-1.5 py-1 text-xs font-semibold"
      >
        <span class="truncate" [matTooltip]="statusLabel">{{ statusLabel }}</span>
      </div>
    }
  `,
  imports: [MatTooltipTruncateDirective, MatTooltip, NgClass],
})
export class QuestionListStatusCellRendererComponent extends BaseCellRendererComponent<
  QuestionStatus | null,
  QuestionItemV2
> {
  get status(): QuestionStatus | null {
    const data = this.params?.data as { status?: QuestionStatus };
    return data?.status ?? null;
  }

  get statusLabel(): string {
    return this.status ? QUESTION_STATUS_TO_LABEL[this.status] : '—';
  }

  get statusClass(): string {
    switch (this.status) {
      case 'PUBLISHED':
        return 'bg-green-100 text-green-600';
      case 'PUBLISHED_V2':
        return 'bg-green-100 text-green-600';
      case 'GENERALLY_AVAILABLE':
        return 'bg-sky-100 text-sky-600';
      case 'DRAFT':
        return 'bg-neutral-50 text-neutral-500';
      case 'DELETED':
        return 'bg-red-100 text-red-600';
      case 'ACTIVE_SEED':
        return 'bg-indigo-100 text-indigo-600';
      case 'INACTIVE_SEED':
        return 'bg-orange-100 text-orange-600';
      default:
        return 'bg-amber-100 text-amber-600';
    }
  }
}
